// ANCHOR Base
import { Modal, SIZE } from 'baseui/modal';

// ANCHOR Model
import { ConfirmationModalVisibility } from '@lyon/scoped-models/confirmation-modal/ConfirmationModalVisibility';
import { ConfirmationModalLogic } from '@lyon/scoped-models/confirmation-modal/ConfirmationModalLogic';

// ANCHOR Components
import { LyonConfirmationModalHead } from './LyonConfirmationModalHead';
import { LyonConfirmationModalBodyInput } from './LyonConfirmationModalBodyInput';
import { LyonConfirmationModalBodyDichotomous } from './LyonConfirmationModalBodyDichotomous';
import { LyonConfirmationModalFoot } from './LyonConfirmationModalFoot';

// ANCHOR Styles
import { MODAL } from './styles';

interface IProps {
  prompt: string;
  contentType?: string;
  loading?: boolean;
  description?: string;
  callback?: () => any;
  asyncCallback?: () => Promise<any>;
  isStrict?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
}

export function LyonConfirmationModal({
  prompt,
  contentType = 'stream',
  callback,
  asyncCallback,
  loading,
  description,
  isStrict = true,
  confirmLabel,
  cancelLabel,
}: IProps) {
  const [isOpen, hide] = ConfirmationModalVisibility.useSelectors((state) => [
    state.state, state.hide,
  ]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={hide}
      closeable
      size={SIZE.default}
      overrides={MODAL}
    >
      <ConfirmationModalLogic.Provider
        prompt={prompt}
        contentType={contentType}
        description={description}
        loading={loading}
        callback={callback}
        asyncCallback={asyncCallback}
        isStrict={isStrict}
        confirmLabel={confirmLabel}
        cancelLabel={cancelLabel}
      >
        <LyonConfirmationModalHead />
        {
          isStrict
            ? <LyonConfirmationModalBodyInput />
            : <LyonConfirmationModalBodyDichotomous />
        }
        <LyonConfirmationModalFoot />
      </ConfirmationModalLogic.Provider>
    </Modal>
  );
}
